import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-hidden-user', {
    color: applyColor(DesignTokens.color.font.default.subtle, '#bfbfbf'),
    fontWeight: 'inherit',
});

